import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { SubscriptionCollector } from '@draeger-academy/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'da-show-more',
    templateUrl: './show-more.component.html',
    styleUrls: ['./show-more.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShowMoreComponent implements OnInit, OnChanges {
    @SubscriptionCollector() private _subs;
    @Output() toggle: EventEmitter<boolean> = new EventEmitter();
    @Input() labelMore: string;
    @Input() labelLess: string;
    @Input() buttonLabelMore: string;
    @Input() buttonLabelLess: string;
    @Input() backgroundColor: 'white' | 'nearwhite' | 'grey' | 'draegerblue' = 'white';
    @Input() expand = false;

    public get label$(): Observable<string> {
        return this._$label.asObservable();
    }

    public get buttonLabel$(): Observable<string> {
        return this._$buttonLabel.asObservable();
    }

    public get showMore$(): Observable<boolean> {
        return this._$showMore.asObservable();
    }

    public get hasMiddleButton$(): Observable<boolean> {
        return this._$buttonLabel.pipe(
            map((data) => {
                return data != null && data !== '';
            })
        );
    }

    private _$label: BehaviorSubject<string> = new BehaviorSubject('');
    private _$buttonLabel: BehaviorSubject<string> = new BehaviorSubject('');
    public _$showMore: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor() {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes['labelMore']) {
            this._$label.next(this.labelMore);
        } else if (changes['labelLess']) {
            this._$label.next(this.labelLess);
        }
        if (changes['buttonLabelMore']) {
            this._$buttonLabel.next(this.buttonLabelMore);
        }
    }

    public ngOnInit(): void {
        this._subs = this.showMore$.subscribe((showMore) => {
            if (showMore && this.labelLess != null) {
                this._$label.next(this.labelLess);
            } else {
                this._$label.next(this.labelMore || '');
            }

            if (showMore && this.buttonLabelLess != null) {
                this._$buttonLabel.next(this.buttonLabelLess);
            } else {
                this._$buttonLabel.next(this.buttonLabelMore || '');
            }
        });

        this._$showMore.next(this.expand);
    }

    public onClick(): void {
        this.expand = !this.expand;
        this._$showMore.next(this.expand);
        this.toggle.emit(this.expand);
    }

    private _reset(): void {
        this._$showMore.next(false);
    }
}
